import { TrophyIcon } from '@heroicons/react/20/solid';
import { Button, Card } from '@radix-ui/themes';
import React from 'react';
import { toCapitalizeFirst } from '#app/utils/textHelpers.ts';
import styles from './FastestTime.module.css';

type RunnerInfo = {
  fullName: string;
  time: string;
  date: string;
  ageClass: string;
  ageGradedPercent: number;
};

type Props = {
  fastestMale?: Array<RunnerInfo>;
  fastestFemale?: Array<RunnerInfo>;
};

export default function FastestTime(props: Props) {
  const { fastestMale, fastestFemale } = props;
  const [selected, setSelected] = React.useState<'male' | 'female'>('male');

  return (
    <Card className="w-full">
			<div className="flex flex-col">
				<div className="absolute right-2 flex gap-x-2">
					<Button
            variant={selected === 'male' ? 'outline' : 'soft'}
            color={selected === 'male' ? 'yellow' : 'gray'}
            onClick={() => setSelected('male')}>

						Male
					</Button>
					<Button
            variant={selected === 'female' ? 'outline' : 'soft'}
            color={selected === 'female' ? 'yellow' : 'gray'}
            onClick={() => setSelected('female')}>

						Female
					</Button>
				</div>
				<div className="text-h5">Top Age-Graded</div>
				<div className="p-2">
					{fastestMale &&
          fastestMale.map((athlete, i) =>
          <DisplayCard
            place={i}
            key={athlete.fullName}
            {...athlete}
            display={selected === 'male'} />

          )}
					{fastestFemale &&
          fastestFemale.map((athlete, i) =>
          <DisplayCard
            place={i}
            key={athlete.fullName}
            {...athlete}
            display={selected === 'female'} />

          )}
				</div>
			</div>
		</Card>);

}

const DisplayCard = (props: RunnerInfo & {display: boolean;place: number;}) => {
  const trophyColor: Record<number, string> = {
    0: '#FFD700',
    1: '#C0C0C0',
    2: '#CD7F32'
  };
  return props.display ?
  <div className="flex justify-between p-1 font-mono text-lg">
			<div className="flex items-center gap-x-2">
				<TrophyIcon
        color={trophyColor[props.place]}
        height="28px"
        className={styles.glow + ' delay-1000'} />

				<div>
					<div className="flex items-center gap-x-2">
						{toCapitalizeFirst(props?.fullName)}
						<span className="text-sm">({props.ageClass})</span>
					</div>
					<div className="font-mono text-sm">{props?.date}</div>
				</div>
			</div>
			<div>{props?.time}</div>
		</div> :

  <div />;

};